export default __webpack_public_path__ + "static/media/thoni_915_2.4db002eb.jpg";